export default {
  pricing: {
    title: "Preços",
    hero: {
      title: "Uma assinatura. Acesso total.",
      subtitle: "Comece grátis. Desbloqueie a experiência completa na web e no mobile.",
      newsletterTitle: "1 year of Linemate+ for $45",
      newsletterSubtitle: "Your discount code is automatically applied at checkout, so just choose the annual plan and you’re good to go.",
      newsletterPriceLine: "US$44.99 pelo ano inteiro",
      newsletterRenewLine: "Renova por US$59.99/ano",
    },
    plans: {
      free: {
        features: [
          "Jogadas em alta diariamente",
          "Taxas de acerto de equipes e jogadores",
          "Histórico de jogos e desempenho",
        ],
      },
      annual: {
        billingShort: "ano",
        billingLong: "anualmente",
        features: [
          "Inclui tudo do plano gratuito +",
          "Todos os sinais de jogada e análise completa",
          "Escalações iniciais, impacto de lesões e tempo",
          "Acesso exclusivo a todos os parlays",
          "Insights mais profundos sobre todos os parlays em alta",
          "Filtros de busca avançados",
          "Opção para selecionar e alterar a visualização de odds",
        ],
      },
      monthly: {
        billingShort: "mês",
        billingLong: "mensalmente",
        features: [
          "Inclui tudo do plano gratuito +",
          "Todos os sinais de jogada e análise completa",
          "Escalações iniciais, impacto de lesões e tempo",
          "Acesso exclusivo a todos os parlays",
          "Insights mais profundos sobre todos os parlays em alta",
          "Filtros de busca avançados",
          "Opção para selecionar e alterar a visualização de odds",
        ],
      },
    },
    actions: {
      currentPlan: "Seu plano atual",
      manage: "Gerenciar",
      upgrade: "Fazer upgrade",
    },
    badges: {
      mostPopular: "Mais popular",
      annualSavings: "Economize até 60% com o plano anual",
    },
    operators: {
      prefix: "Totalmente integrado com",
      highlight: "operadores globais",
      suffix: "para uma experiência sem atrito da pesquisa à aposta",
    },
    sections: {
      fullPicture: "Veja o quadro completo antes de apostar",
      signals: "Desbloqueie todos os sinais para ter mais contexto",
    },
    testimonials: {
      trusted: "Confiado por<br/>900 mil apostadores esportivos",
      betslips: "Mais de<br/>1M+ betslips criados",
      previous: "Depoimentos anteriores",
      next: "Próximos depoimentos",
      items: [
        {
          title: "Realmente o app mais bem desenhado que encontrei em muito tempo.",
          description: "Tudo está exatamente onde precisa estar, cada seleção funciona como esperado, e o app é muito bem pensado. Ele tem muita informação, mas continua eficiente e organizado. Como fã de estatísticas, reconheço o ótimo design do Linemate e a facilidade de encontrar boas jogadas.",
        },
        {
          title: "Melhor app de todos",
          description: "Este é 100% o melhor app para apostas esportivas. Depois de testar por alguns dias, fiquei convencido. Recomendo muito a versão paga para aproveitar tudo o que ele oferece. Você não vai se decepcionar.",
        },
        {
          title: "O melhor",
          description: "Já testei muitos apps de estatísticas. O Linemate é aquele para o qual sempre volto. Eles oferecem muito de graça, continuam adicionando recursos sem tirar nada, e o plano Plus realmente vale o preço. O suporte respondeu em 5 minutos. Dá para ver que eles querem ser o app de referência.",
        },
        {
          title: "Surpresa positiva",
          description: "Se você é novo e segue props cegamente, os resultados vão variar; ainda é preciso ter estratégia. Baixei o Linemate depois que meus parlays erravam por pouco, e meu primeiro parlay de 7 legs de props de jogador bateu. Com a primeira semana grátis, o preço mensal vale facilmente.",
        },
        {
          title: "Ótimo app!",
          description: "Nenhum app de apostas é perfeito, mas este me deu os melhores resultados até agora. Tudo se baseia em estatísticas e dados reais. A versão gratuita é sólida, e a assinatura é ainda melhor.",
        },
        {
          title: "Um app que se destaca",
          description: "Um excelente app que realmente se destaca, acessível e com recursos fortes para pesquisa. No geral, ótimo trabalho.",
        },
      ],
    },
    comparison: {
      premium: "Anual/Mensal",
      included: "Incluído",
      notIncluded: "Não incluído",
    },
    popup: {
      billedAnnually: "Cobrado anualmente",
      savePercent: "Economize {{percent}}%",
      upgradeForJust: "Faça upgrade por apenas {{price}}/{{billingPeriod}}",
      dismiss: "Fechar",
    },
  },
};
